import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import SvgIcon from '../../../Icons';

type Props = {
  onCreateOffer: () => void;
};

export const OfferNotFound: React.FC<Props> = ({ onCreateOffer }) => {
  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      flexDirection={'column'}
      sx={{
        border: '1px solid #F1F2F1',
        borderRadius: '6px',
        padding: '18px 12px',
      }}
      gap={8}
    >
      <Box
        display='flex'
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        gap={'16px'}
      >
        <Box display='flex' mt={5}>
          <SvgIcon name='NewOffer' inheritViewBox sx={{ fontSize: 100 }} />
        </Box>
        <Box>
          <Typography color={'#232832'} fontSize={'18px'} fontWeight={500} textAlign={'center'}>
            Create your first Collab offer
          </Typography>
          <Typography color='#707070' fontSize={'13px'} textAlign={'center'}>
            Invite models and creators to promote your business in exchange for your products or
            services
          </Typography>
        </Box>
      </Box>
      <Button
        fullWidth
        id='btn-create-offer'
        variant='outlined'
        sx={{
          padding: '8px 0',
          fontSize: '15px',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
        onClick={onCreateOffer}
      >
        <span>Create Collab offer</span>
      </Button>
    </Box>
  );
};